import React from 'react';
import { Button, HStack, Icon } from '@chakra-ui/react';
import { MdTheaters, MdTv, MdVideoLibrary, MdFavorite, MdHistory } from 'react-icons/md';
import type { BrowseTab } from '../context/StreamPlayerContext';
import { streamGhostOnDarkHover } from '../darkThemeButtonProps';

const TABS: { id: BrowseTab; label: string; icon: React.ElementType }[] = [
  { id: 'live', label: 'Live TV', icon: MdTv },
  { id: 'movies', label: 'Movies', icon: MdTheaters },
  { id: 'series', label: 'Series', icon: MdVideoLibrary },
  { id: 'favorites', label: 'Favorites', icon: MdFavorite },
];

interface Props {
  value: BrowseTab;
  onChange: (t: BrowseTab) => void;
  /** Highlight browse tabs only when the main browse view is showing */
  browseNavActive: boolean;
  recentsActive: boolean;
  onOpenRecents: () => void;
}

export function ModeTabs({ value, onChange, browseNavActive, recentsActive, onOpenRecents }: Props) {
  return (
    <HStack
      spacing={1}
      flexWrap="wrap"
      px={{ base: 3, md: 4 }}
      py={2}
      borderBottomWidth="1px"
      borderColor="whiteAlpha.100"
      bg="blackAlpha.200"
      minH="48px"
      align="center"
    >
      {TABS.map((t) => {
        const active = browseNavActive && !recentsActive && value === t.id;
        return (
          <Button
            key={t.id}
            size="xs"
            h="28px"
            px={3}
            leftIcon={<Icon as={t.icon} boxSize={3.5} />}
            variant={active ? 'solid' : 'ghost'}
            colorScheme="teal"
            color={active ? 'gray.900' : 'whiteAlpha.700'}
            fontWeight={active ? '600' : '500'}
            {...(!active ? streamGhostOnDarkHover : {})}
            onClick={() => onChange(t.id)}
          >
            {t.label}
          </Button>
        );
      })}
      <Button
        size="xs"
        h="28px"
        px={3}
        leftIcon={<Icon as={MdHistory} boxSize={3.5} />}
        variant={recentsActive ? 'solid' : 'ghost'}
        colorScheme="teal"
        color={recentsActive ? 'gray.900' : 'whiteAlpha.700'}
        fontWeight={recentsActive ? '600' : '500'}
        {...(!recentsActive ? streamGhostOnDarkHover : {})}
        onClick={onOpenRecents}
      >
        Recents
      </Button>
    </HStack>
  );
}
